export enum MissedCoinsPlace {
  marketDropdown = "marketDropdown",
  payToken = "payToken",
}
